<template>
    <div class="video-self">
        <div class="aspect-ratio-spacer">
            <div class="video-wrapper">
                <video v-show="isReady" ref="localVideo" autoplay webkit-playsinline playsinline muted="muted"></video>
                <!--<div v-show="isReady" class="video-self-displayname">{{displayname}}</div>-->
                <div v-show="!isReady" class="getting-ready">Getting ready...</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:"VideoSelf",
        data () {
            return {
                isReady:false,
                hasVideo:null,
                stream:null,
                displayname:null
            }
        },
        methods: {
            setVideoReady: function (isReady) {
                this.isReady = isReady;
            },
            setVideo: function (displayname, stream, hasVideo) {
                this.displayname = displayname;
                this.stream = stream;
                this.hasVideo = hasVideo;
                if(hasVideo) {
                    console.log(stream.getTracks());
                    this.$janus.attachMediaStream(this.$refs.localVideo, stream)
                }
            },
            unsetVideo: function () {
                this.stream = null;
                this.hasVideo = null;
                this.isReady = false;
                this.displayname = false;
            }
        },
        videoroom: {
            isLocalParticipantReady: function (isReady) {
                this.setVideoReady(isReady);

            },
            addLocalParticipant: function (displayname, stream, hasVideo) {
                this.setVideo(displayname, stream, hasVideo);
            },
            removeLocalParticipant: function () {
                this.unsetVideo();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/VideoSelf.vue